'use strict';

(() => {
    const initializeSlider = () => {
        const relatedProductsSections = document.querySelectorAll('.bs-related-products');

        relatedProductsSections.forEach((relatedProductSection) => {
            const swiper = relatedProductSection.querySelector('.bs-related-products__swiper');

            new Swiper(swiper, {
                spaceBetween: 16,
                slidesPerView: 1.185,
                pagination: {
                    el: relatedProductSection.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                },
                breakpoints: {
                    481: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 32
                    }
                }
            });
        });    
    };

    if(manualRecommendations) {
        initializeSlider();
    } else {
        document.addEventListener('recommendations_loaded', () => {
            initializeSlider();
         });
    }
})();